// extracted by mini-css-extract-plugin
export default {"tableHederCell":"TableADT_tableHederCell__wxHdr","mobileTable":"TableADT_mobileTable__1bf6k","mobileTableContainer":"TableADT_mobileTableContainer__iMW5T"};